import React from 'react';
import {observer} from 'mobx-react';
import {StandingsWidgetRowViewModel} from "../../models/standings-widget.row-view-model";
import {StandingsWidgetController} from "../../standings-widget.controller";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetTableCell} from "./standings-widget.table.cell";

export class StandingsWidgetTableStatsCellsProps extends BaseProps {
  row: StandingsWidgetRowViewModel;
  controller: StandingsWidgetController;
}

export const StandingsWidgetTableStatsCells = observer(({controller, row}: StandingsWidgetTableStatsCellsProps) => {
  const {competitor, cells} = row;

  return cells?.map((cell, index: Number) => {
    const hasBorder: Boolean = (((cells[index - 1]?.isMajor && !cell?.isMajor) || index === 0));

    const cellProps = {
      controller,
      competitor,
      cell,
      hasBorder,
      index
    }

    return <StandingsWidgetTableCell {...cellProps} key={index}/>
  })
});
